import { toRef, watch, computed } from 'vue'
import { usePopup } from '@/composables/ui/usePopup'
import ContactsDropdown from '@/components/booking-manager/parts/ContactsDropdown.vue'

export default ContactsDropdown

export const useVenueContacts = (props, { emit }) => {
    const contacts = toRef(props, 'contacts')
    const showContacts = toRef(props, 'showContacts')
    const userInput = toRef(props, 'userInput')

    const { popupOpen: dropdownOpen } = usePopup()

    watch(
        showContacts,
        (show) => {
            const _filteredContacts = _filterContacts(contacts.value, userInput.value)
            if (_filteredContacts.length) {
                dropdownOpen.value = show
            } else {
                dropdownOpen.value = false
                show = false
            }
        },
        { immediate: true }
    )
    function addContactEmail(contact) {
        emit('selected-contact', contact)
    }

    const filteredContacts = computed(() => {
        if (userInput.value) {
            return _filterContacts(contacts.value, userInput.value)
        } else {
            return contacts.value
        }
    })
    function _filterContacts(data, input) {
        input = input.trim().toLowerCase()

        return data.filter((item) => {
            return (
                !item.selected &&
                (item.band_email.toLowerCase().includes(input) || item.band_name.toLowerCase().includes(input))
            )
        })
    }

    return {
        dropdownOpen,

        addContactEmail,
        filteredContacts
    }
}
